import BeerIcon from './beer'
import BeerCanIcon from './beer-can'
import BeerKegIcon from './beer-keg'
import BeerPackIcon from './beer-pack'
import ChampagneGlassIcon from './champagne-glass'
import GrapesIcon from './grapes'
import HopIcon from './hop'
import RedWineFullIcon from './red-wine-full'
import RedWineLightIcon from './red-wine-light'
import RedWineLightMediumIcon from './red-wine-light-medium'
import RedWineMediumIcon from './red-wine-medium'
import RedWineMediumFullIcon from './red-wine-medium-full'
import VarietalIcon from './varietal'
import WhiskyGlassIcon from './whisky-glass'
import WhiteWineFullIcon from './white-wine-full'
import WhiteWineLightIcon from './white-wine-light'
import WhiteWineLightMediumIcon from './white-wine-light-medium'
import WhiteWineMediumIcon from './white-wine-medium'
import WhiteWineMediumFullIcon from './white-wine-medium-full'
import WineBarrelIcon from './wine-barrel'
import WineBottleChampagneIcon from './wine-bottle-champagne'
import WineBottleMagnumIcon from './wine-bottle-magnum'
import WineBottleSmallIcon from './wine-bottle-small'
import WineBottleStandardIcon from './wine-bottle-standard'
import WineCanIcon from './wine-can'
import WineCanPackIcon from './wine-can-pack'
import WineCaseIcon from './wine-case'
import WineGlassIcon from './wine-glass'
import WinePackIcon from './wine-pack'
import AlcoholPercentageIcon from './alcohol-percentage'
import BrandyBottleIcon from './brandy-bottle'
import CocktailSmall1Icon from './cocktail-small-1'
import CocktailTall1Icon from './cocktail-tall-1'
import CocktailTall2Icon from './cocktail-tall-2'
import CocktailTall3Icon from './cocktail-tall-3'
import CocktailTall4Icon from './cocktail-tall-4'
import CocktailTall5Icon from './cocktail-tall-5'
import CocktailTall6Icon from './cocktail-tall-6'
import CocktailTall7Icon from './cocktail-tall-7'
import CocktailTall8Icon from './cocktail-tall-8'
import GiftBoxIcon from './gift-box'
import GinCocktailIcon from './gin-cocktail'
import SpiritBottle1LabeledIcon from './spirit-bottle-1-labeled'
import SpiritBottle1Icon from './spirit-bottle-1'
import SpiritBottle10Icon from './spirit-bottle-10'
import SpiritBottle11Icon from './spirit-bottle-11'
import SpiritBottle2Icon from './spirit-bottle-2'
import SpiritBottle3Icon from './spirit-bottle-3'
import SpiritBottle4Icon from './spirit-bottle-4'
import SpiritBottle5Icon from './spirit-bottle-5'
import SpiritBottle6Icon from './spirit-bottle-6'
import SpiritBottle7Icon from './spirit-bottle-7'
import SpiritBottle8Icon from './spirit-bottle-8'
import SpiritBottle9Icon from './spirit-bottle-9'
import SpiritBottleSmallIcon from './spirit-bottle-small'
import SpiritsIcon from './spirits'
import TastingTubeLabeledIcon from './tasting-tube-labeled'
import TastingTubeIcon from './tasting-tube'
import WhiskyGlassIceIcon from './whisky-glass-ice'

export default {
  BeerIcon,
  BeerCanIcon,
  BeerKegIcon,
  BeerPackIcon,
  ChampagneGlassIcon,
  GrapesIcon,
  HopIcon,
  RedWineFullIcon,
  RedWineLightIcon,
  RedWineLightMediumIcon,
  RedWineMediumIcon,
  RedWineMediumFullIcon,
  WhiteWineFullIcon,
  WhiteWineLightIcon,
  WhiteWineLightMediumIcon,
  WhiteWineMediumIcon,
  WhiteWineMediumFullIcon,
  VarietalIcon,
  WhiskyGlassIcon,
  WineBarrelIcon,
  WineBottleChampagneIcon,
  WineBottleMagnumIcon,
  WineBottleSmallIcon,
  WineBottleStandardIcon,
  WineCanIcon,
  WineCanPackIcon,
  WineCaseIcon,
  WineGlassIcon,
  WinePackIcon,
  AlcoholPercentageIcon,
  BrandyBottleIcon,
  CocktailSmall1Icon,
  CocktailTall1Icon,
  CocktailTall2Icon,
  CocktailTall3Icon,
  CocktailTall4Icon,
  CocktailTall5Icon,
  CocktailTall6Icon,
  CocktailTall7Icon,
  CocktailTall8Icon,
  GiftBoxIcon,
  GinCocktailIcon,
  SpiritBottle1LabeledIcon,
  SpiritBottle1Icon,
  SpiritBottle10Icon,
  SpiritBottle11Icon,
  SpiritBottle2Icon,
  SpiritBottle3Icon,
  SpiritBottle4Icon,
  SpiritBottle5Icon,
  SpiritBottle6Icon,
  SpiritBottle7Icon,
  SpiritBottle8Icon,
  SpiritBottle9Icon,
  SpiritBottleSmallIcon,
  SpiritsIcon,
  TastingTubeLabeledIcon,
  TastingTubeIcon,
  WhiskyGlassIceIcon
}
